export default __webpack_public_path__ + "static/media/animatedBanner.b3852632.png";